import type { SVGProps } from "react";
const SvgIconTrophy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M807 256h-96.75v-39c0-13.81-11.19-25-25-25h-346.5c-13.81 0-25 11.19-25 25v39H217c-13.81 0-25 11.19-25 25v109.25c0 74.57 55.91 136.33 128.02 145.56 20.04 77.57 85.97 136.88 166.98 147.12V782H364.5c-13.81 0-25 11.19-25 25s11.19 25 25 25h295c13.81 0 25-11.19 25-25s-11.19-25-25-25H537v-99.07c81.01-10.24 146.94-69.55 166.98-147.12C776.09 526.58 832 464.82 832 390.25V281c0-13.81-11.19-25-25-25M242 390.25V306h71.75v177.72C272.48 472.67 242 434.96 242 390.25m540 0c0 44.71-30.48 82.42-71.75 93.47V306H782z" />
  </svg>
);
export default SvgIconTrophy;
